import { render } from "./SetPassword.vue?vue&type=template&id=85073dfe&scoped=true&lang=pug"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"

import "./SetPassword.vue?vue&type=style&index=0&id=85073dfe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-85073dfe"

export default script